import React, { useState } from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import axios from "axios";

const MediaRender = (props) => {
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const updateBackend = async (vId, vduration) => {
    await axios
      .post(
        localStorage.getItem("basurl") + "/mediaupdateduration",
        {
          id: vId,
          duration: vduration,
        },
        { headers: { "mojo-access-tokens": user.token } }
      )
      .then((response) => {
        console.log(response.data.message);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
  switch (props.data.file_type) {
    case "video/mp4":
      //console.log(props);
      if (props.data.file_duration == null || props.data.file_duration == "") {
        let media = new Audio(
          `${localStorage.getItem("baseimageurl")}/media/${props.data.link}`
        );
        media.onloadedmetadata = function () {
          let intDuration = media.duration;
          let intMins = Math.floor((intDuration % 3600) / 60);
          let intSecs = Math.floor((intDuration % 3600) % 60);
          let strDuration =
            String(intMins).padStart(2, "0") +
            ":" +
            String(intSecs).padStart(2, "0");
          props.data.file_duration = strDuration;
          updateBackend(props.data.id, intDuration);
        };
      } else {
        let intDuration = props.data.file_duration;
        let intMins = Math.floor((intDuration % 3600) / 60);
        let intSecs = Math.floor((intDuration % 3600) % 60);
        let strDuration =
          String(intMins).padStart(2, "0") +
          ":" +
          String(intSecs).padStart(2, "0");
        props.data.file_duration = strDuration;
      }
      return (
        <LazyLoadComponent>
          <div>{props.data.file_duration} mins</div>
          <video className={props.rclass} controls alt={props.data.link}>
            <source
              src={`${localStorage.getItem("baseimageurl")}/media/${
                props.data.link
              }`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </LazyLoadComponent>
      );
    case "image/jpeg":
    case "image/png":
      return (
        <LazyLoadComponent>
          <img
            className={props.rclass}
            src={`${localStorage.getItem("baseimageurl")}/media/${
              props.data.link
            }`}
            alt={props.data.link}
          />
        </LazyLoadComponent>
      );
    case "audio/mpeg":
      return (
        <LazyLoadComponent>
          <audio className={props.rclass} controls alt={props.data.link}>
            <source
              src={`${localStorage.getItem("baseimageurl")}/media/${
                props.data.link
              }`}
              type="audio/mpeg"
            />
            Your browser does not support the audio tag.
          </audio>
        </LazyLoadComponent>
      );
    default:
      return (
        <LazyLoadComponent>
          <span>---</span>
        </LazyLoadComponent>
      );
  }
};

export default MediaRender;
